module.exports = __webpack_public_path__ + "img/arrow_up.42aa3069.svg";